import { render } from "./pinboard-comment.html?vue&type=template&id=7c60a45c"
import script from "./PinboardComment.vue?vue&type=script&lang=ts"
export * from "./PinboardComment.vue?vue&type=script&lang=ts"

import "./pinboard-comment.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script